<!-- 基本信息 -->
<template>
  <div class="container">
    <div class="vue">
      <div class="header   flex flexColumn">
        <div class="head-title borderB">
          <div class="text">基本信息</div>
        </div>
        <div class="headSearch">
          <div class="headSearch-left Fs14">
            <div class="form-data group">
              <span>姓名：</span>
              <el-input v-model="SearchForm.name" style="width: 150px;" size="mini" placeholder="" clearable></el-input>
            </div>
            <div class="form-data group">
              <span>手机号：</span>
              <el-input v-model="SearchForm.tel" style="width: 150px;" size="mini" placeholder="" clearable></el-input>
            </div>
            <div class="form-data group">
              <span>所属机构：</span>
              <el-input v-model="SearchForm.organ" size="mini" placeholder="" clearable></el-input>
            </div>
            <div class="form-data group">
              <span>所在地址：</span>
              <el-input v-model="SearchForm.area" size="mini" placeholder="" clearable></el-input>
            </div>
            <!-- <div class="form-data group">
              <span>区域：</span>
              <el-cascader
                size="mini"
                :options="options"
                v-model="SearchForm.selectedOptions"
                @change="cascaderChange"
              >
              </el-cascader>
            </div> -->
            <!-- <div class="form-data group">
              <span>注册时间：</span>
              <el-date-picker size="mini" v-model="SearchForm.time" type="date" placeholder="选择日期"></el-date-picker>
            </div> -->
            <div class="form-data group">
              <el-button @click="SearchBut" round type="primary" size="mini"
                >搜索</el-button
              >
            </div>
          </div>
          <div class="headSearch-right">
            <!-- <el-button
              @click="addStatusBut"
              icon="el-icon-plus"
              type="primary"
              size="small"
              >新增用户</el-button
            > -->
          </div>
        </div>
      </div>
      <div class="content">
        <el-table
          :header-cell-style="{ background: '#f5f5f5' }"
          :data="UserList.list"
          style="width: 100%">
          <el-table-column prop="id" label="#" min-width="1"> </el-table-column>
          <el-table-column prop="name" label="用户名" min-width="2"> </el-table-column>
          <el-table-column prop="tel" label="手机号" min-width="2"> </el-table-column>
          <el-table-column prop="sex" label="性别" min-width="1">
            <template slot-scope="scope">
              <span>{{ scope.row.sex | filterSex }}</span>
            </template></el-table-column>
          <el-table-column prop="birth" label="出生日期" min-width="2">
            <template slot-scope="scope">
              <span>{{ scope.row.birth | filterTime(1) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="idcard" label="身份证号" min-width="3"> </el-table-column>
          <el-table-column prop="serviceItem" label="服务项目" min-width="3"> </el-table-column>
          <!-- <el-table-column label="最后登录时间">
            <template slot-scope="scope">
              <span>{{ scope.row.loginTime | filterTime }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="ip" label="登录ip"> </el-table-column>
          <el-table-column label="注册时间">
            <template slot-scope="scope">
              <span>{{ scope.row.registerTime | filterTime }}</span>
            </template>
          </el-table-column> -->
          <el-table-column prop="organ" label="所属机构" min-width="2"> </el-table-column>
          <!-- <el-table-column prop="invites" label="邀请者"> </el-table-column> -->
          <!-- <el-table-column prop=" " label="区域"  v-if=" UserList.list ='nullnullnull'"> </el-table-column> -->
          <el-table-column prop="area" label="区域" min-width="3"></el-table-column>
          <el-table-column label="操作" min-width="4">
            <template slot-scope="scope">
              <el-button @click="organClick(scope.row)" round type="primary" size="mini">修改归属</el-button>
              <el-button @click="serveClick(scope.row)" round type="primary" size="mini">服务信息</el-button>
            </template>
          </el-table-column>
          <!-- <el-table-column label="预警信息">
            <template slot-scope="scope">
              <el-button
                @click="warningClick(scope.row)"
                type="text"
                size="small"
                >查看</el-button
              >
            </template>
          </el-table-column> -->
        </el-table>
        <div class="Pagination flex">
          <div class="text">
            <span>共{{ UserList.total }}条记录，</span>
            <span class="pageNum">{{ UserList.pageNum }}</span>
            <span>/{{ UserList.pages }}页</span>
          </div>
          <el-pagination
            v-if="UserList !== ''"
            @current-change="handleCurrentChange"
            :current-page.sync="UserList.pageNum"
            :page-size="UserList.pageSize"
            layout="prev, pager, next, jumper"
            :total="UserList.total"
          >
          </el-pagination>
        </div>
      </div>

      <el-dialog title="所属机构" width="500px" :visible.sync="personDialogVisible" :append-to-body="true">
        <div>
          <el-form ref="personForm" :model="personForm" :rules="rules" label-width="80px">
            <el-row type="flex" justify="space-between" align="middle">
              <el-col>
                <el-form-item label="机构名称" prop="organ">
                  <el-input v-model="personForm.organ"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="personDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="personUpdateClick">确 定</el-button>
        </div>
      </el-dialog>

    </div>
  </div>
</template>

<script>
import { apiGetBUserList, apiUpdateBUser } from '@/api/clientManage'
import { regionDataPlus } from 'element-china-area-data' // 引入区域三级联动https://www.npmjs.com/package/element-china-area-data
export default {
  name: '',
  props: [''],
  data() {
    return {
      UserList: '', // 列表
      options: regionDataPlus, // 区域省列表
      pages: {
        page: 1, // 页数
        size: 50
      },
      selectedOptions: [],
      SearchForm: {
        tel: '',
        name: '',
        organ: '',
        area: '',
        // time: ''
      },
      rules: {
        organ: [
          { required: true, message: '请输入所属机构', trigger: 'blur' },
        ],
      },
      personForm: {},
      personDialogVisible: false,
    }
  },

  components: {},

  computed: {},

  beforeMount() {},

  mounted() {
    this.GetBUserList()
  },

  methods: {
    // 搜索
    SearchBut() {
      this.GetBUserList()
    },
    // 新增用户
    addStatusBut() {},
    // 区域变换时触发
    cascaderChange() {},
    // 列表-服务信息
    serveClick(row) {
      const data = {
        uids: row.id
      }
      this.$router.push({
        path: '/serveInfo',
        query: {
          info: this.$Base64.encode(JSON.stringify(data))
        }
      })
    },
    organClick(row) {
      this.personForm = {};
      this.personForm.id = row.id;
      this.personDialogVisible = true;
    },
    // 列表-预警信息
    warningClick(row) {
      const data = {
        id: row.id
      }
      this.$router.push({
        path: '/warningInfo',
        query: {
          info: this.$Base64.encode(JSON.stringify(data))
        }
      })
    },
    // 分页
    handleCurrentChange(val) {
      this.pages.page = val
      console.log(`当前页: ${val}`)
      this.GetBUserList()
    },
    // 接口
    // 获取基本用户的列表
    GetBUserList() {
      // let stime = null;
      // if(this.SearchForm.time) {
      //   stime = this.SearchForm.time.getTime();
      // }
      apiGetBUserList({
        name: this.SearchForm.name,
        tel: this.SearchForm.tel,
        organ: this.SearchForm.organ,
        area: this.SearchForm.area,
        // time: stime,
        page: this.pages.page,
        pageSize: this.pages.size
      }).then(res => {
        if (res.status === 0) {
          this.UserList = res.data
          //张改  
          for(let i = 0; i < res.data.list.length; i++ ){
                if(res.data.list[i].area =='nullnullnull'){
                    res.data.list[i].area = ''
                }
          }
          console.log(this.UserList)
        }
      })
    },
    personUpdateClick() {
      this.personForm.organ = this.personForm.organ.trim();
      apiUpdateBUser(this.personForm).then(res => {
        if (res.status === 0) {
          this.GetBUserList();
          this.personDialogVisible = false;
        }
      })
    },

  },

  watch: {}
}
</script>
<style lang="scss" scoped>
.flex {
  display: flex;
}
.FZ0875 {
  font-size: 0.875em;
}
.textalignLeft {
  text-align: left;
}
.vue {
  padding: 0 10px;
  background-color: #fff;
  border-left: 2px solid #119685;
  .header {
    height: 92px;
    .headSearch {
      .headSearch-left {
        .form-data {
          // span {
          //   width: 90px;
          // }
          /deep/ .el-date-editor,
          .el-input,
          .el-cascader {
            width: 200px;
          }
        }
      }
      .headSearch-right {
        // width: 15%;
      }
    }
    .text {
      text-align: left;
      // font-size: 0.875em;
      color: #119685;
      padding: 10px 5px;
    }
  }
  .content {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: calc(100vh - 214px);
    /deep/ .el-table {
      overflow: auto;
      height: calc(100vh - 272px);
    }
    /deep/ .el-table .warning-row {
      background: oldlace;
    }

    /deep/ .el-table .success-row {
      background: #f0f9eb;
    }
    .Pagination {
      justify-content: space-between;
      padding: 10px 20px;
      align-items: center;
      font-size: 0.875em;
      color: #7b7b7b;
      .text {
        .pageNum {
          color: #119685;
        }
      }
    }
  }
}
.dialog {
}
</style>
